import React, { useState, useCallback } from 'react';
import { ErrorMessageContext } from './error-message.context';

export default function ErrorMessageontextWrapper(props: React.PropsWithChildren<{}>) {
  const [messageConfig, setMessageConfig] = useState({ message: "", active: false });


  const setErrorMessage = useCallback((config: any) => {
    setMessageConfig(config);
  }, []);

  return (
    <ErrorMessageContext.Provider value={{ messageConfig, setErrorMessage }}>
      {props.children}
    </ErrorMessageContext.Provider>
  );
}